import { calculateInstallmentAmount, calculateActualNominalRate, calculateEffectiveInterestRate } from './loanUtils';

class LoanDetailCalculation {
    loanAmount: number;

    nominalInterestRate: number;

    repaymentPeriodYears: number;

    establishmentFee: number;

    installmentFee: number;

    effectiveInterestRate: number;

    installmentAmount: number;

    installmentAmountInclFee: number;

    actualNominalRate: number;

    totalLoanCost: number;

    constructor(
        loanAmount: number,
        nominalInterestRate: number,
        repaymentPeriodYears: number,
        establishmentFee: number,
        installmentFee: number,
    ) {
        this.loanAmount = loanAmount;
        this.nominalInterestRate = nominalInterestRate;
        this.repaymentPeriodYears = repaymentPeriodYears;
        this.establishmentFee = establishmentFee;
        this.installmentFee = installmentFee;

        this.installmentAmount = calculateInstallmentAmount(loanAmount, nominalInterestRate, repaymentPeriodYears);
        this.installmentAmountInclFee = this.installmentAmount + installmentFee;

        const rates = calculateActualNominalRate(
            loanAmount,
            this.installmentAmount,
            nominalInterestRate,
            installmentFee,
            establishmentFee,
            repaymentPeriodYears,
        );

        this.actualNominalRate = rates.actualNominalRate;
        this.effectiveInterestRate = calculateEffectiveInterestRate(this.actualNominalRate);
        this.totalLoanCost = rates.totalInstallmentCosts;
    }

    public getDetails(): {
        nominalInterestRate: number;
        installmentAmountInclFee: number;
        effectiveInterestRate: number;
    } {
        return {
            nominalInterestRate: Number(this.nominalInterestRate.toFixed(2)),
            installmentAmountInclFee: Number(this.installmentAmountInclFee.toFixed(2)),
            effectiveInterestRate: Number(this.effectiveInterestRate.toFixed(2)),
        };
    }
}

export default LoanDetailCalculation;
